import { render } from "./AmazonWahoolLogin.vue?vue&type=template&id=24b9f416&scoped=true"
import script from "./AmazonWahoolLogin.vue?vue&type=script&lang=js"
export * from "./AmazonWahoolLogin.vue?vue&type=script&lang=js"

import "./AmazonWahoolLogin.vue?vue&type=style&index=0&id=24b9f416&lang=less&scoped=true"
import "./AmazonWahoolLogin.vue?vue&type=style&index=1&id=24b9f416&lang=less"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b9f416"]])

export default __exports__